'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _toArray = require('./toArray');

var _toArray2 = _interopRequireDefault(_toArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'join',
    immutable: 'join',
    all: function all() {
        var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ",";
        return function (value) {
            return (0, _toArray2.default)()(value).join(separator);
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/join.js
// module id = 903
// module chunks = 35783957827783